import { useMutation, useNotify } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IShowPdfButton {
  id: string;
}

const ShowPdfButton = ({ id }: IShowPdfButton) => {
  const notify = useNotify();

  const [getPdfUrl, { loading }] = useMutation(
    {
      type: "getOne",
      resource: `subcontractorPurchaseInvoices`,
      payload: { id: id },
    },
    {
      onSuccess: ({ data }) => {
        if (data.pdfUrl) {
          window.open(data.pdfUrl, "_blank");
        } else {
          notify("The PDF Url doesn't exist.", "warning");
        }
      },
      onFailure: (error) => {
        notify(`The PDF Url doesn't exist. error: ${error.message}`, "warning");
      },
    }
  );

  return (
    <StyledButton variant="outlined" onClick={() => getPdfUrl()}>
      {loading ? "Loading" : `Show PDF`}
    </StyledButton>
  );
};

export default ShowPdfButton;
